import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'

import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

import Content from './Content'

export interface CellProps {
  timeRanges: CustomTimeRange[]
  dayType: AttendanceCustomTimeRangeDayEnum
  showNotDefined: boolean
  settingId: number
  base?: boolean
}

const Cell = ({ dayType, timeRanges, showNotDefined, settingId, base = false }: CellProps) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)
  const showTimeBlock = !!timeRanges.length
  const showAddBlock = !showTimeBlock && hover && showNotDefined
  const paddingTop = base && !showAddBlock && !showNotDefined ? 's8' : undefined
  const height = showAddBlock ? 'full' : undefined

  return (
    <Box
      background="grey100"
      height={height}
      cursor="pointer"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      paddingTop={paddingTop}
      minHeight="s80"
    >
      <Content
        timeRanges={timeRanges}
        dayType={dayType}
        hover={hover}
        base={base}
        showNotDefined={showNotDefined}
        settingId={settingId}
      />
    </Box>
  )
}

export default Cell
